"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Teaser = exports.TEASER_TYPE = exports.TEASER_STYLE_TYPE = exports.TEASER_LOGO_POSITION_TYPE = exports.TEASER_IMAGE_POSITION_TYPE = exports.TEASER_CONTENT_POSITION_TYPE = exports.STYLES_WITH_BACKGROUND_BANNER = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _getComponentDataAttributes = require("b2b-components/utils/getComponentDataAttributes");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _BannerBackground = require("./BannerBackground");
require("./Teaser.scss");
let TEASER_TYPE = exports.TEASER_TYPE = /*#__PURE__*/function (TEASER_TYPE) {
  TEASER_TYPE["banner"] = "banner";
  TEASER_TYPE["size100"] = "size100";
  TEASER_TYPE["size66"] = "size66";
  TEASER_TYPE["size50"] = "size50";
  TEASER_TYPE["size33"] = "size33";
  return TEASER_TYPE;
}({});
let TEASER_STYLE_TYPE = exports.TEASER_STYLE_TYPE = /*#__PURE__*/function (TEASER_STYLE_TYPE) {
  TEASER_STYLE_TYPE["light"] = "light";
  TEASER_STYLE_TYPE["dark"] = "dark";
  TEASER_STYLE_TYPE["DMKGreen"] = "DMK-Green";
  TEASER_STYLE_TYPE["DMKBlue"] = "DMK-Blue";
  TEASER_STYLE_TYPE["DMKGreyBlue"] = "DMK-GreyBlue";
  TEASER_STYLE_TYPE["DMKWarmGrey"] = "DMK-WarmGrey";
  TEASER_STYLE_TYPE["DMKYellow"] = "DMK-Yellow";
  TEASER_STYLE_TYPE["DMKRose"] = "DMK-Rose";
  TEASER_STYLE_TYPE["DMKRed"] = "DMK-Red";
  TEASER_STYLE_TYPE["DMKViolet"] = "DMK-Violet";
  TEASER_STYLE_TYPE["DMKPetrol"] = "DMK-Petrol";
  return TEASER_STYLE_TYPE;
}({});
let TEASER_CONTENT_POSITION_TYPE = exports.TEASER_CONTENT_POSITION_TYPE = /*#__PURE__*/function (TEASER_CONTENT_POSITION_TYPE) {
  TEASER_CONTENT_POSITION_TYPE["left"] = "left";
  TEASER_CONTENT_POSITION_TYPE["right"] = "right";
  return TEASER_CONTENT_POSITION_TYPE;
}({});
let TEASER_LOGO_POSITION_TYPE = exports.TEASER_LOGO_POSITION_TYPE = /*#__PURE__*/function (TEASER_LOGO_POSITION_TYPE) {
  TEASER_LOGO_POSITION_TYPE["bottom"] = "bottom";
  TEASER_LOGO_POSITION_TYPE["top"] = "top";
  return TEASER_LOGO_POSITION_TYPE;
}({});
let TEASER_IMAGE_POSITION_TYPE = exports.TEASER_IMAGE_POSITION_TYPE = /*#__PURE__*/function (TEASER_IMAGE_POSITION_TYPE) {
  TEASER_IMAGE_POSITION_TYPE["center"] = "center";
  TEASER_IMAGE_POSITION_TYPE["left"] = "left";
  TEASER_IMAGE_POSITION_TYPE["right"] = "right";
  return TEASER_IMAGE_POSITION_TYPE;
}({});
const STYLES_WITH_BACKGROUND_BANNER = exports.STYLES_WITH_BACKGROUND_BANNER = [TEASER_STYLE_TYPE.DMKGreen, TEASER_STYLE_TYPE.DMKBlue, TEASER_STYLE_TYPE.DMKGreyBlue, TEASER_STYLE_TYPE.DMKWarmGrey, TEASER_STYLE_TYPE.DMKYellow, TEASER_STYLE_TYPE.DMKRose, TEASER_STYLE_TYPE.DMKRed, TEASER_STYLE_TYPE.DMKViolet, TEASER_STYLE_TYPE.DMKPetrol];
const Teaser = _ref => {
  let {
    buttonLabel,
    className,
    content,
    imageUrl,
    logoUrl,
    onClick,
    title,
    url,
    dataAttributes,
    contentPosition = TEASER_CONTENT_POSITION_TYPE.right,
    imagePosition = TEASER_IMAGE_POSITION_TYPE.center,
    logoPosition = TEASER_LOGO_POSITION_TYPE.top,
    styleType = TEASER_STYLE_TYPE.light,
    type = TEASER_TYPE.size100,
    contentInnerClassName,
    contentTitleClassName,
    contentTextClassName
  } = _ref;
  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    url && onClick?.(url);
  };
  const isBannerBackgroundDisplayed = STYLES_WITH_BACKGROUND_BANNER.includes(styleType);
  const rootClassName = (0, _classnames.default)('cds-Teaser', {
    'cds-Teaser--Banner': type === TEASER_TYPE.banner,
    'cds-Teaser--Size100': type === TEASER_TYPE.size100,
    'cds-Teaser--Size66': type === TEASER_TYPE.size66,
    'cds-Teaser--Size50': type === TEASER_TYPE.size50,
    'cds-Teaser--Size33': type === TEASER_TYPE.size33,
    [`cds-Teaser--${(0, _upperCase.upperCaseFirst)(styleType || '')}`]: styleType !== TEASER_STYLE_TYPE.light,
    'cds-Teaser--DMK': STYLES_WITH_BACKGROUND_BANNER.includes(styleType),
    [`cds-Teaser--${(0, _upperCase.upperCaseFirst)(contentPosition || '')}`]: contentPosition !== TEASER_CONTENT_POSITION_TYPE.right && type !== TEASER_TYPE.size33 && type !== TEASER_TYPE.size50 && type !== TEASER_TYPE.size66
  }, className);
  const logoClassName = (0, _classnames.default)('cds-Teaser-Logo', {
    'cds-Teaser-Logo--Bottom': logoPosition === TEASER_LOGO_POSITION_TYPE.bottom
  });
  const imageClassName = (0, _classnames.default)('cds-Teaser-Image', {
    [`cds-Teaser-Image--${(0, _upperCase.upperCaseFirst)(imagePosition)}`]: imagePosition !== TEASER_IMAGE_POSITION_TYPE.center
  });
  const contentInnerClass = (0, _classnames.default)('cds-Teaser-ContentInner', contentInnerClassName);
  const contentTitleClass = (0, _classnames.default)('cds-Teaser-Title', contentTitleClassName);
  const contentTextClass = (0, _classnames.default)('cds-Teaser-Text', contentTextClassName);
  const child = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isBannerBackgroundDisplayed && /*#__PURE__*/_react.default.createElement(_BannerBackground.BannerBackground, {
    className: "cds-Teaser-DMKBackground"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: imageClassName,
    style: {
      backgroundImage: `url(${imageUrl})`
    }
  }), logoUrl && /*#__PURE__*/_react.default.createElement("img", {
    alt: title,
    className: logoClassName,
    src: logoUrl
  }), (title || content || buttonLabel && url) && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Teaser-Content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: contentInnerClass
  }, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: contentTitleClass
  }, title), content && /*#__PURE__*/_react.default.createElement("div", {
    className: contentTextClass
  }, content), buttonLabel && url && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Teaser-CTA"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    size: type === TEASER_TYPE.banner ? _Button.BUTTON_SIZE.default : _Button.BUTTON_SIZE.small,
    onClick: handleClick
  }, buttonLabel)))));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _getComponentDataAttributes.getComponentDataAttributes)(dataAttributes), {
    className: rootClassName
  }), url ? /*#__PURE__*/_react.default.createElement("a", {
    className: "cds-Teaser-WrapperLink",
    href: url,
    onClick: handleClick
  }, child) : child);
};
exports.Teaser = Teaser;
//# sourceMappingURL=Teaser.js.map